<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light" v-if="canViewDriverAll || canViewPurchases">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchDeposit" class="form-inline my-2 my-lg-0">
                    <input
                            class="form-control mr-sm-2"
                            type="search"
                            v-model="search.driver_name"
                            placeholder="คนขับ"
                            aria-label="Search"/>
                    <input
                            class="form-control mr-sm-2"
                            type="search"
                            v-model="search.license_plate"
                            placeholder="ทะเบียนรถ"
                            aria-label="Search"/>
                    <b-form-select v-model="search.transport_type"
                                   :options="transportType" >
                    </b-form-select>&nbsp
                    <button @click="searchDeposit"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อ-นามสกุล</th>
                    <th scope="col">จำนวนคงเหลือ</th>
                    <th scope="col">ยอดเงินฝากสะสม</th>
                    <th scope="col">ยอดเบิกสะสม</th>
                    <th scope="col">ดูข้อมูล</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in driverList">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.deposit_total-data.withdraw_total | currency }}</td>
                    <td>{{data.deposit_total | currency }}</td>
                    <td>{{data.withdraw_total | currency }}</td>
                    <td>
                        <button @click="showDepositData(data.id)"
                                class="btn btn-default next">
                            ดูข้อมูล
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="driverList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getDriverPage">
            </vue-pagination>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"/>
        </b-modal>
        <br/>
        <!--<pre class="alert alert-primary">{{ driverList }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../Pagination";
    import {
        canViewDriver,
        canViewDriverAll,
        canViewPurchases,
    } from "../../../util/Permissions";
    import Loading from "../../Utility/Loading";

    export default {
        components: {Loading, VuePagination},
        name: "deposit-list",
        data(){
           return {
                search:{
                    driver_name:"",
                    license_plate:"",
                    transport_type : ""
                },
               event_submit : false,
               msg : 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่',
               status_loading : 1,
           }
        },
        created(){
            this.$store.dispatch('Deposit/setDeposit', 1);
            this.$store.dispatch("TransportType/setTransportTypes");
        },
        computed:{
            canViewDriver,
            canViewDriverAll,
            canViewPurchases,
            ...mapState({
                driverList:state=>{
                    return state.Deposit.deposit
                },
                transportType:state=>{
                    return [
                        {
                            value: "",
                            text: "ค้นหาประเภทรถ"
                        },
                        ...state.TransportType.transportTypeList.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
                dataPaginate:state=>{
                    return state.Deposit.dataPaginate
                }
            })
        },
        methods:{
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            showDepositData(id){
                if(id){
                    this.showLoadingModal();
                    let page = this.dataPaginate.current_page;
                    this.$store.dispatch('Driver/getDriverById',id)
                        .then(()=>{
                            this.$store.dispatch("Deposit/showDepositTable",{
                                driver_id : id,
                                page : 1,
                            }).then(()=>{
                                let route = this.$router.resolve({
                                    name : "deposit-information"
                                });
                                window.open(route.href,'_blank');
                                this.hideLoadingModal();
                                this.getCurrentPage(page);
                            }).catch(()=>{
                                this.msg = 'ดาวโหลดข้อมูล ไม่สำเร็จ';
                                this.status_loading = 3;
                            })
                        }).catch(()=>{
                        this.msg = 'ดาวโหลดข้อมูล ไม่สำเร็จ';
                        this.status_loading = 3;
                    });
                }
            },
            searchDeposit(){
                this.event_submit = true;
                this.$store.dispatch('Deposit/searchDeposit',{
                    search : this.search
                })
            },
            getDriverPage(){
                const page = this.dataPaginate.current_page;
                if(this.event_submit){
                    this.$store.dispatch('Deposit/searchDeposit',{
                        page : page,
                        search : this.search
                    });
                }
                else{
                    this.$store.dispatch('Deposit/setDeposit',page);
                }
            },
            getCurrentPage(page){
                this.$store.dispatch('Deposit/setDeposit',page);
            }
        }
    }
</script>

<style scoped>

</style>
